import type { Locale } from "@/i18n/config";
import { localizedText } from "@/i18n/text";

/**
 * A landlord's accepted file type in words. The backend sends the enum
 * (`PDF`, `PICTURE`, …), which used to be printed as is — "PICTURE" on the
 * Swedish site too.
 */
export function documentTypeLabel(type: string, locale: Locale): string {
  switch (type.trim().toUpperCase()) {
    case "PDF":
      return "PDF";
    case "PICTURE":
      return localizedText(locale, "Bild", "Image");
    case "DOCX":
      return "Word";
    case "TXT":
      return localizedText(locale, "Textfil", "Text file");
    default:
      return type;
  }
}

/** The accepted file types as one line ("PDF, Bild"), or null when there are none. */
export function documentTypesLabel(
  types: readonly string[] | null | undefined,
  locale: Locale
): string | null {
  if (!types?.length) {
    return null;
  }
  return types.map((type) => documentTypeLabel(type, locale)).join(", ");
}
